import React from "react";
import { Pagination as BootstrapPagination } from "react-bootstrap";
import {
  FaArrowLeft,
  FaArrowRight,
  FaStepForward,
} from "react-icons/fa";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const renderPaginationItems = () => {
    if (totalPages <= 1) return null;

    const items = [];
    
    // Previous button
    items.push(
      <BootstrapPagination.Prev
        key="prev"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <FaArrowLeft />
      </BootstrapPagination.Prev>
    );

    // Calculate sliding window of 3 pages
    let startPage = currentPage - 1;
    let endPage = currentPage + 1;

    // Adjust if near start
    if (currentPage <= 2) {
      startPage = 1;
      endPage = Math.min(3, totalPages);
    }
    
    // Adjust if near end
    if (currentPage >= totalPages - 1) {
      startPage = Math.max(1, totalPages - 2);
      endPage = totalPages;
    }

    // Show page numbers in sliding window
    for (let page = startPage; page <= endPage; page++) {
      items.push(
        <BootstrapPagination.Item
          key={page}
          active={page === currentPage}
          onClick={() => handlePageChange(page)}
        >
          {page}
        </BootstrapPagination.Item>
      );
    }

    // Next button
    items.push(
      <BootstrapPagination.Next
        key="next"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <FaArrowRight />
      </BootstrapPagination.Next>
    );

    // Last page button (only show if not already in the window)
    if (totalPages > 3 && endPage < totalPages) {
      items.push(
        <BootstrapPagination.Item
          key="last"
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage === totalPages}
          title="Go to last page"
        >
          <FaStepForward />
        </BootstrapPagination.Item>
      );
    }

    return items;
  };

  if (totalPages <= 1) return null;

  return (
    <div className="pagination-container">
      <div className="pagination-content">
        <div className="pagination-info">
          Page {currentPage} of {totalPages}
        </div>
        <BootstrapPagination className="pagination-controls mb-0">
          {renderPaginationItems()}
        </BootstrapPagination>
      </div>
    </div>
  );
};

export default Pagination;